export function getRandomEmoji() {
  const ranges = [
    [0x1f300, 0x1f5ff], // Symbols and pictographs
    [0x1f600, 0x1f64f], // Emoticons
    [0x1f680, 0x1f6ff], // Transport and map symbols
    [0x1f700, 0x1f77f], // Alchemical symbols
  ];

  // Pick a random range
  const [start, end] = ranges[Math.floor(Math.random() * ranges.length)];

  // Generate a random code point within the range
  const randomCodePoint = Math.floor(Math.random() * (end - start + 1)) + start;

  return String.fromCodePoint(randomCodePoint);
}
